import { BulkEntryRequirement } from './BulkEntryRequirement';

export default BulkEntryRequirement;
